let Summary1940=[
    {"Countryname":" ",
    "OZ":0,
    "ME":32,
    "NU":6,
    "DI":13,
    "HR":14,
    "CO":51,
    "EC":28,
    "OT":0
    }]
export default Summary1940